import setIn from 'transmute/setIn';
import { ValueForKeyPath } from 'immutable-less/transmute';

interface setIn {
  <
    Data,
    KeyPath extends readonly any[],
    Value = ValueForKeyPath<KeyPath, Data>,
  >(
    keyPath: KeyPath,
    value: Value,
    data: Data
  ): Data;

  (keyPath: readonly any[], value: unknown): <Data>(data: Data) => Data;
  <KeyPath extends readonly any[]>(
    key: KeyPath
  ): <Data, Value = ValueForKeyPath<KeyPath, Data>>(
    value: Value,
    data: Data
  ) => Data;
  (keyPath: readonly any[]): (value: unknown) => <Data>(data: Data) => Data;
}

export default setIn as setIn;
